// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"d6eb276f","223":"a77f7353","368":"8824b522","453":"ae9c510e","987":"93ea7f1c"}[chunkId] + ".chunk.js";
};